<script lang="ts">
  import { fade } from "svelte/transition";
  import FlashMessage from "@shared/svelte/Components/Flash/Message.svelte";
  import FlashMessageStore from "@shared/svelte/Stores/FlashMessageStore";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import type { Message } from "@shared/types/Message";
  import { onDestroy } from "svelte";

  let flashMessages: Message[];
  let hasMessagesToShow = false;
  const unsubscribe = FlashMessageStore.subscribe(n => {
    flashMessages = n;
  });

  onDestroy(() => {
    unsubscribe();
  });

  function closeFlash(message) {
    let idx = flashMessages.indexOf(message);
    flashMessages.splice(idx, 1);
    flashMessages = flashMessages; // This line is needed to force a re-render
  }

  $: {
    hasMessagesToShow = flashMessages.length > 0;
    for (let message of flashMessages) {
      if (!message._timer && !message.keep) {
        message._timer = setTimeout(() => closeFlash(message), message.timeout || 5000);
      }
    }
  }
</script>

{#if hasMessagesToShow}
  <FizzStyles extraClasses="flash-messages__wrapper">
    {#each flashMessages as message}
      <div
        class="flash-messages__message"
        transition:fade={{ delay: 0, duration: 200, easing: c => c }}
      >
        <FlashMessage on:close={() => closeFlash(message)} {message} />
      </div>
    {/each}
  </FizzStyles>
{/if}
